const getters = {
    activeIndex: state => state.app.activeIndex,
    language: state => state.app.language,
    darkMode: state => state.app.darkMode
}

export default getters